import React from 'react';
import { ShoppingBag } from 'lucide-react';
import { Link } from 'react-router-dom';

/**
 * Reusable Merchandise Transparency Notice.
 * Variants: shop | product | checkout | event | donation
 */
const NOTICES = {
  shop: {
    text: 'Merchandise purchases support the mission of Novena Humanitarian Foundation and are not tax-deductible donations.',
  },
  product: {
    text: 'Merchandise purchases support the mission of Novena Humanitarian Foundation and are not tax-deductible donations.',
  },
  checkout: {
    text: 'Merchandise purchases support the mission of Novena Humanitarian Foundation and are not tax-deductible donations.',
  },
  event: {
    text: 'Merchandise purchases support the mission of Novena Humanitarian Foundation and are not tax-deductible donations.',
  },
  donation: {
    text: 'Looking to support through purchases?',
    hasLink: true,
  },
};

export const MerchTransparencyNotice = ({ variant = 'shop' }) => {
  const notice = NOTICES[variant] || NOTICES.shop;

  if (variant === 'donation') {
    return (
      <div className="bg-[#F8F9FA] border border-[#E5E7EB] rounded-lg px-4 py-3 flex items-center gap-3 flex-wrap" data-testid="merch-transparency-donation">
        <ShoppingBag className="w-4 h-4 text-[#BA1826] flex-shrink-0" />
        <p className="text-xs text-[#4B5563]">
          {notice.text}{' '}
          <Link to="/shop" className="font-semibold text-[#BA1826] hover:underline">Visit our shop</Link>.
          {' '}Merchandise purchases support our mission but are not tax-deductible.
        </p>
      </div>
    );
  }

  return (
    <div className="bg-[#F0F9FF] border border-[#BAE6FD] rounded-lg px-4 py-3 flex items-start gap-2.5" data-testid={`merch-transparency-${variant}`}>
      <ShoppingBag className="w-4 h-4 text-[#0369A1] mt-0.5 flex-shrink-0" />
      <p className="text-xs text-[#0C4A6E] leading-relaxed">{notice.text}</p>
    </div>
  );
};
